import { BaseTelemetryEvent, ValidTelemetryEvent } from '../../../data-catalog-shared';

export interface CreateContentItemFromTelemetryEvent extends ValidTelemetryEvent<BaseTelemetryEvent> {
  type: 'create_content_from_item';
  content_type: string;
  connection_type: string;
  data_type: string;
}

export enum ContentType {
  Workbook = 'workbook',
  Flow = 'Flow'
}

export enum DataType {
  Database = 'database',
  Table = 'table'
}
